import React, { useContext, useEffect, useState } from "react";
import { find, get, isEmpty, isNull } from "lodash";
import { Form, Tabs, Tab, Modal, Button } from "react-bootstrap";
import { faTimes, faTrashAlt } from "@fortawesome/pro-light-svg-icons";
import { faPencilAlt } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckCircle,
  faExclamationTriangle,
} from "@fortawesome/pro-light-svg-icons";
import { Formik } from "formik";
import {
  manageRkaasStore,
  MANAGE_TRADE_POST_API_ERROR,
  setManageRkaasToastInfo,
} from "../../../../contexts";
import {
  manageRkaasFormNames,
  formFields,
  FLOW_TYPES,
  tranformListToDropdownValues,
  MANAGE_RKAAS_ROUTES,
  getPathWithParam,
  getAdvancedPathWithParam,
} from "../../../../utils";
import { useRouterParams, useDeepEffect } from "../../../../abstracts";
import {
  LoaderWrapper,
  ManageRkaasLayout,
  DeleteWarning,
} from "../../../../components";
import MarketTimingRulesFields from "./MarketTimingRules/MarketTimingRules";
import BasicDetailsFields from "./BasicDetails/BasicDetails";
import RedemptionFees from "./RedemptionFees/RedemptionFeesContainer";
import History from "./History/History";
import investmentTabGroup from "../../../../mocks/investmentTabGroup.json";
import {
  addMasterInvestment,
  getInvestment,
  getMasterInvestment,
  deleteMasterInvestmentById,
} from "../../../../services";
import PerformanceData from "./PerfomanceData/PerformanceData.jsx";
import history from "../../../../mocks/investmentHistory.json";

var today = new Date();

const initialValues = {
  includeInvestmentIn: 1,
  accountType: 1,
  restrictedPeriod: 1,
  isInvestmentQDIA: true,
  isEquityWashRuleApplicable: false,
  applyMarketTiming: false,
  investmentSubjectToRedemptionFee: false,
  isTieredFees: false,
  holdingPeriod: 1,
  precision: 4,
  fromDate: new Date(today.setDate(today.getDate() - 30)),
  toDate: new Date(),
};

const mockData = {
  asOfDate: new Date(),
  current: 5,
  ytd: 10,
  fromInception: 10,
  threeMonths: 15,
  oneYear: 20,
  threeYears: 40,
  fiveYears: 60,
  tenYears: 80,
  investmentHistory: history.map((_) => {
    return {
      investmentPrice: _.investmentPrice,
      investmentAccuralFactor: _.investmentAccuralFactor,
    };
  }),
};

const AddInvestmentContainer = (props) => {
  const { history } = props;
  const { state, dispatch } = useContext(manageRkaasStore);
  const { flow, investmentId } = useRouterParams();
  const [newFlow, setNewFlow] = useState(
    flow != FLOW_TYPES.ADD
      ? flow != FLOW_TYPES.SAVE
        ? FLOW_TYPES.EDIT
        : FLOW_TYPES.SAVE
      : FLOW_TYPES.ADD
  );
  const [rule, setRule] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(0);
  const handleClose = () => {
    setIsModalOpen(false);
  };
  const formName = manageRkaasFormNames.ADD_INVESTMENT;
  const fields = formFields[formName];
  const apiData = get(state, "api.data", {});
  const investmentsData = get(apiData, "investments", []);
  const intInvestmentId = parseInt(investmentId, 10);
  const formValues = find(investmentsData, {
    id: intInvestmentId,
  });
  const investmentsList = tranformListToDropdownValues(
    get(apiData, "investments", []),
    "name",
    "id"
  );
  const [marketTimingRules, setMarketTimingRules] = useState([]);
  const [redemptionFeesTierDetails, setRedemptionFeesTierDetails] = useState(
    []
  );
  const [isInnerFormDirty, setIsInnerFormDirty] = useState(false);
  const [keyValue, setKeyValue] = useState(1);
  const [saveTriggered, setSaveTriggered] = useState(false);
  const tabGroups = investmentTabGroup;
  const [response, setResponse] = useState();
  const [showWarning, setShowWarning] = useState(false);
  const [type, setType] = useState();
  const DeleteToastMessageHead = "Delete Investment?";
  const DeleteToastMessage = "You are attempting to delete investment.";
  const [investmentTypes, setInvestmentTypes] = useState([]);

  const [tabColors, setTabColors] = useState({
    1: false,
    2: false,
    3: false,
    4: false,
    5: false,
  });

  const [tabColorGrey, setTabColorGrey] = useState({
    1: false,
    2: false,
    3: false,
    4: false,
    5: false,
  });

  const tabChange = (key) => {
    setKeyValue(key);
  };

  const buttons = [
    {
      label: "Cancel",
      variant: "secondary",
      type: "button",
      flow: [FLOW_TYPES.ADD, FLOW_TYPES.SAVE],
      link: getPathWithParam({
        path: MANAGE_RKAAS_ROUTES.INVESTMENT,
      }),
    },
    {
      label: "Save",
      variant: "primary",
      type: "submit",
      flow: [FLOW_TYPES.ADD],
    },
    {
      label: "",
      variant: "link",
      type: "button",
      flow: [FLOW_TYPES.EDIT],
      icon: faTimes,
      link: getPathWithParam({
        path: MANAGE_RKAAS_ROUTES.INVESTMENT,
      }),
    },
    {
      label: "",
      variant: "link",
      type: "button",
      flow: [FLOW_TYPES.EDIT],
      icon: faPencilAlt,
      onClick: () => {
        history.push(
          getAdvancedPathWithParam({
            path: MANAGE_RKAAS_ROUTES.ADD_INVESTMENT,
            pathParam: [FLOW_TYPES.SAVE, intInvestmentId],
          })
        );
        setNewFlow(FLOW_TYPES.SAVE);
      },
    },
    {
      label: "",
      variant: "link",
      type: "button",
      flow: [FLOW_TYPES.EDIT],
      icon: faTrashAlt,
      onClick: () => {
        deleteInvestment();
      },
    },
    {
      label: "Save",
      variant: "primary",
      type: "submit",
      flow: [FLOW_TYPES.SAVE],
    },
  ];

  const responseFail = (response, setFieldTouched, setFieldError) => {
    setIsLoading(false);
    var color = { 1: false, 2: false, 3: false, 4: false, 5: false };
    for (var i = 0; i < response.errorMessages.length; i++) {
      var _ = response.errorMessages[i];
      setFieldError(_.controlName, `${_.errorCode} : ${_.message}`);
      setFieldTouched(_.controlName, true);
      // setFieldTouched(_.controlName, _.message);

      var x = [tabGroups[_.controlName]];
      x == 1
        ? (color[1] = true)
        : x == 2
        ? (color[2] = true)
        : x == 3
        ? (color[3] = true)
        : x == 4
        ? (color[4] = true)
        : x == 5 && (color[5] = true);
    }
    setTabColors(color);
  };

  useDeepEffect(() => {
    if (flow !== FLOW_TYPES.ADD) {
      setIsLoading(true);
      getMasterInvestment(investmentId)
        .then((response) => {
          setIsLoading(false);
          setType(response.type);
          setResponse(response);
          setMarketTimingRules(response.marketTimingRules);
        })
        .catch((error) => {});
    }
  }, [investmentId]);

  const onFormSubmit = (
    values,
    { setSubmitting, setFieldTouched, setFieldError }
  ) => {
    setSaveTriggered(true);
    setTabColorGrey({ 1: false, 2: false, 3: false, 4: false, 5: false });
    var data = {
      ...values,
      investmentHistory: undefined,
      asOfDate: undefined,
      current: undefined,
      ytd: undefined,
      fromInception: undefined,
      threeMonths: undefined,
      oneYear: undefined,
      threeYears: undefined,
      fiveYears: undefined,
      tenYears: undefined,
      marketTimingRules: marketTimingRules,
      inceptionDate: values?.inceptionDate ? values?.inceptionDate : null,
    };
    setIsLoading(true);
    setSubmitting(true);
    addMasterInvestment(data)
      .then((response) => {
        if (response.isSuccessful) {
          setIsLoading(false);
          dispatch(
            setManageRkaasToastInfo({
              showToast: true,
              toastMessage: `Data saved successfully`,
            })
          );
          history.push(
            getPathWithParam({
              path: MANAGE_RKAAS_ROUTES.INVESTMENT,
            })
          );
        } else {
          responseFail(response, setFieldTouched, setFieldError);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        dispatch({
          type: MANAGE_TRADE_POST_API_ERROR,
          payload: error,
        });
        throw error;
      });
  };

  const deleteInvestment = () => {
    setShowWarning(true);
  };

  const handleConfirmClick = () => {
    setShowWarning(false);
    deleteMasterInvestmentById(intInvestmentId)
      .then((response) => {
        if (!response.isSuccessful) {
          var x = response.errorMessage;
          if (
            x.controlName == null &&
            x.errorCode !== null &&
            x.message !== null
          ) {
            setErrorMsg(`${x.errorCode} : ${x.message}`);
            setIsModalOpen(true);
          }
        } else {
          dispatch(
            setManageRkaasToastInfo({
              showToast: true,
              toastMessage: `Data deleted successfully`,
            })
          );
          history.push(
            getPathWithParam({
              path: MANAGE_RKAAS_ROUTES.INVESTMENT,
            })
          );
        }
      })
      .catch((error) => {
        //Handle Errors
      });
  };

  const handleCancelClick = () => {
    setShowWarning(false);
  };

  const isEdit = newFlow === FLOW_TYPES.EDIT;
  const isSave = newFlow === FLOW_TYPES.SAVE;
  const isAdd = newFlow === FLOW_TYPES.ADD;

  const layoutHeader = investmentId && "Investment";

  const setTabGrey = (tab) => {
    tab == 1
      ? (tabColorGrey[1] = true)
      : tab == 2
      ? (tabColorGrey[2] = true)
      : tab == 3
      ? (tabColorGrey[3] = true)
      : tab == 4
      ? (tabColorGrey[4] = true)
      : tab == 5 && (tabColorGrey[5] = true);
    setTabColorGrey(tabColorGrey);
  };

  const setTabColor = (tabValue) => {
    if (isAdd)
      return keyValue == tabValue && !saveTriggered
        ? "black"
        : saveTriggered
        ? tabColors[tabValue]
          ? "red"
          : "green"
        : "grey";
    else
      return tabColorGrey[tabValue] && !saveTriggered
        ? "grey"
        : saveTriggered
        ? tabColors[tabValue]
          ? "red"
          : "green"
        : "green";
  };

  const setTabClass = (tabValue) => {
    return keyValue == tabValue
      ? "active"
      : saveTriggered
      ? tabColors[tabValue]
        ? "error"
        : "green"
      : "";
  };

  const setTabIcon = (tabValue) => {
    return tabColors[tabValue] == true ? faExclamationTriangle : faCheckCircle;
  };

  return (
    <Formik
      initialValues={{
        ...initialValues,
        ...response,
        ...formValues,
        ...mockData,
      }}
      onSubmit={onFormSubmit}
      enableReinitialize
      validateOnChange={false}
      validateOnBlur={false}
    >
      {(formProps) => {
        const {
          handleChange,
          setFieldValue,
          handleSubmit,
          setValues,
          setTouched,
          values,
          setSubmitting,
          setFieldError,
          fieldValue,
          ...rest
        } = formProps;

        return (
          <div style={{ height: "90vh" }}>
            <Form
              autoComplete="off"
              className="h-100"
              onSubmit={handleSubmit}
              validated={!isEmpty(rest.errors)}
            >
              <LoaderWrapper isLoading={isLoading}>
                <ManageRkaasLayout
                  layoutHeader={layoutHeader}
                  buttons={buttons}
                  pageFlow={newFlow || flow}
                >
                  <div className="addInvestment-tabs-head">
                    {type == 1 && (
                      <Tabs
                        activeKey={keyValue}
                        transition={false}
                        onSelect={tabChange}
                        mountOnEnter
                        unmountOnExit
                      >
                        <Tab
                          eventKey={1}
                          title={
                            <div>
                              <FontAwesomeIcon
                                icon={setTabIcon(1)}
                                color={setTabColor(1)}
                                className={"mr-1"}
                              />
                              <span className="tabName">Basic Details</span>
                            </div>
                          }
                          tabClassName={setTabClass(1)}
                        >
                          <BasicDetailsFields
                            {...formProps}
                            fields={fields}
                            isEdit={isEdit}
                            isSave={isSave}
                            isAdd={isAdd}
                            setType={setType}
                            setTabGrey={setTabGrey}
                            investmentId={investmentId}
                            initialValues={initialValues}
                            investmentTypes={investmentTypes}
                            setInvestmentTypes={setInvestmentTypes}
                          />
                        </Tab>
                      </Tabs>
                    )}
                    {type != 1 && (
                      <>
                        <Tabs
                          activeKey={keyValue}
                          transition={false}
                          onSelect={tabChange}
                          mountOnEnter
                          unmountOnExit
                        >
                          <Tab
                            eventKey={1}
                            title={
                              <div>
                                <FontAwesomeIcon
                                  icon={setTabIcon(1)}
                                  color={setTabColor(1)}
                                  className={"mr-1"}
                                />
                                <span className="tabName">Basic Details</span>
                              </div>
                            }
                            tabClassName={setTabClass(1)}
                          >
                            <BasicDetailsFields
                              {...formProps}
                              fields={fields}
                              isEdit={isEdit}
                              isSave={isSave}
                              isAdd={isAdd}
                              setType={setType}
                              setTabGrey={setTabGrey}
                              investmentId={investmentId}
                              investmentTypes={investmentTypes}
                              setInvestmentTypes={setInvestmentTypes}
                            />
                          </Tab>

                          <Tab
                            eventKey={2}
                            title={
                              <div>
                                <FontAwesomeIcon
                                  icon={setTabIcon(2)}
                                  color={setTabColor(2)}
                                  className={"mr-1"}
                                />
                                <span className="tabName">Redemption Fees</span>
                              </div>
                            }
                            tabClassName={setTabClass(2)}
                          >
                            <RedemptionFees
                              {...formProps}
                              fields={fields}
                              isEdit={isEdit}
                              isSave={isSave}
                              isAdd={isAdd}
                              redemptionFeesTierDetails={
                                redemptionFeesTierDetails
                              }
                              setRedemptionFeesTierDetails={
                                setRedemptionFeesTierDetails
                              }
                              setTabGrey={setTabGrey}
                            />
                          </Tab>
                          <Tab
                            eventKey={3}
                            title={
                              <div>
                                <FontAwesomeIcon
                                  icon={setTabIcon(3)}
                                  color={setTabColor(3)}
                                  className={"mr-1"}
                                />
                                <span className="tabName">
                                  Market Timing Rules
                                </span>
                              </div>
                            }
                            tabClassName={setTabClass(3)}
                          >
                            <MarketTimingRulesFields
                              {...formProps}
                              fields={fields}
                              isEdit={isEdit}
                              isSave={isSave}
                              errorList={rest.errors}
                              {...{ isInnerFormDirty, setIsInnerFormDirty }}
                              marketTimingRules={marketTimingRules}
                              setMarketTimingRules={setMarketTimingRules}
                              setTabGrey={setTabGrey}
                            />
                          </Tab>
                          <Tab
                            eventKey={4}
                            title={
                              <div>
                                <FontAwesomeIcon
                                  icon={setTabIcon(4)}
                                  color={setTabColor(4)}
                                  className={"mr-1"}
                                />
                                <span className="tabName">
                                  Performance Data
                                </span>
                              </div>
                            }
                            tabClassName={setTabClass(4)}
                          >
                            <PerformanceData
                              {...formProps}
                              fields={fields}
                              isEdit={isEdit}
                              isSave={isSave}
                              setTabGrey={setTabGrey}
                              investmentId={investmentId}
                            />
                          </Tab>
                          <Tab
                            eventKey={5}
                            title={
                              <div>
                                <FontAwesomeIcon
                                  icon={setTabIcon(5)}
                                  color={setTabColor(5)}
                                  className={"mr-1"}
                                />
                                <span className="tabName">History</span>
                              </div>
                            }
                            tabClassName={setTabClass(5)}
                          >
                            <History
                              fields={fields}
                              isEdit={isEdit}
                              isSave={isSave}
                              precision={get(values, "precision")}
                            />
                          </Tab>
                        </Tabs>
                      </>
                    )}
                  </div>
                </ManageRkaasLayout>
                <DeleteWarning
                  DeleteToastMessageHead={DeleteToastMessageHead}
                  DeleteToastMessage={DeleteToastMessage}
                  showModal={showWarning}
                  handleConfirmClick={handleConfirmClick}
                  handleCancelClick={handleCancelClick}
                />
                <Modal show={isModalOpen} onHide={handleClose}>
                  <Modal.Body style={{ borderTop: "5px solid #f94f50" }}>
                    <div className="text-right">
                      <FontAwesomeIcon
                        icon={faTimes}
                        color="#000"
                        onClick={handleClose}
                      />
                    </div>
                    <div className="d-flex">
                      <div className="pd-15">
                        <FontAwesomeIcon
                          icon={faExclamationTriangle}
                          color="#f94f50"
                          size="3x"
                        />
                      </div>
                      <div className="remove-text">
                        <p>{errorMsg}</p>
                        <br />
                        <Button className="cancel-btn" onClick={handleClose}>
                          Ok
                        </Button>
                      </div>
                    </div>
                  </Modal.Body>
                </Modal>
              </LoaderWrapper>
            </Form>
          </div>
        );
      }}
    </Formik>
  );
};

export default AddInvestmentContainer;
